import { MdDeleteOutline } from "react-icons/md";
import CartonInfoBox from "./CartonInfoBox";

export default function CartTable({items,handleRemove}){
    return(
        <table className="w-full text-sm md:text-base text-center border-collapse">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-3">عکس</th>
            <th className="p-3">عنوان</th>
            <th className="p-3">وزن</th>
            <th className="p-3">تعداد</th>
            <th className="p-3">حذف</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            const key = `${item.id}-${item.weight}`;
            const isCarton= item.weight === 'کارتن';
            return (
              <tr key={key} className="border-t">
                <td className="p-2">
                  <img
                    src={item.image || "/images/default-product.png"}
                    alt={item.title}
                    className="w-16 h-16 object-cover rounded-md mx-auto"
                  />
                </td>
                <td className="p-2 text-[10px] md:text-sm font-semibold">{item.title}</td>
                <td className="p-2 text-[10px] md:text-sm font-semibold">
                  {item.weight}
                  {isCarton && (
                  <div className="mt-2.5 flex justify-center">
                    <CartonInfoBox />
                  </div>
                )}
                  </td>
                <td className="p-2 text-[10px] md:text-sm font-semibold">{item.quantity}</td>
                <td className="p-2">
                  <button
                    onClick={() => handleRemove(item.id, item.weight)}
                    className="text-red-600 hover:text-red-800 transition"
                  >
                    <MdDeleteOutline size={20} />
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    )
}